import {
  createGenerateClassName,
  StylesProvider,
} from '@material-ui/core/styles'
import React from 'react'
import { Suspense } from 'react'
import ReactDOM from 'react-dom'

import RegionChooserButton from '../RegionChooserButton'

export default (element: Element) => {
  const generateClassName = createGenerateClassName({
    disableGlobal: true,
    productionPrefix: 'regionChooserButtonCoreJss',
    seed: 'regionChooserButton',
  })

  try {
    ReactDOM.render(
      <StylesProvider generateClassName={generateClassName}>
        <Suspense fallback={<div></div>}>
          <RegionChooserButton />
        </Suspense>
      </StylesProvider>,
      element
    )
  } catch (err) {
    console.error(err)
  }
}
